import React, { useEffect } from 'react';
import {
    Switch,
    Route,
    useLocation
} from "react-router-dom";

import routes from '../../routes'
import {
    StyledContent
} from "./styled";

const PageContainer = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            {props.children}
        </>
    )
}


const Content = () => {
    const location = useLocation()
    const contentComponents = routes.map((route) => {
        const Page = route.component;

        return (
            <Route
                key={'route-' + route.path}
                path={route.path}
                exact={true}
            >
                <StyledContent className={"Content"}>
                    <PageContainer>
                        <Page />
                    </PageContainer>
                </StyledContent>
            </Route>
        )})

    return (

        <Switch location={location}>
            {contentComponents}
        </Switch>

    )
}

export default Content;